import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const Check: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 24, ...rest }, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
   <path d="M6.00004 12L9.78253 16L18 8" stroke={color} strokeWidth="2" strokeLinecap="round" />
</svg>);
export default Check;
